import React from "react";
import './BannerTrapeziod.scss'

interface BannerTrapezoidProps {
    className?: string;
}
export const BannerTrapezoid: React.FC<BannerTrapezoidProps> = ({className}) => {
    return (
        <svg width="414" height="148" viewBox="0 0 414 148" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M400.531 136.156H399.995L0 137.014L0.267972 136.442L17.2746 31.8421H17.8105L339.14 5.60101L338.872 6.26814L400.531 136.156ZM1.74182 136.156L399.593 135.203L337.532 6.64936L18.3464 32.7951L1.74182 136.156Z" fill="#FF4D07"/>
            <path d="M29.4468 21.0562L16.1482 147.954L414 119.14L309.827 0L29.4468 21.0562Z" fill="#FFF600"/>
            <text className="banner-trapeziod-title" x={45} y={55}>Neuroborn Cats:</text>
            <text className="banner-trapeziod-description" x={42} y={85}>
                The Cynical 18+ Cyberpunk MMO
            </text>
            <text className="banner-trapeziod-description" x={42} y={110}>
                Everyone Will Talk About
            </text>
        </svg>
    )
}
